<template>
	<div>
		<h2>{{ type.contenttype_label }}</h2>

		<!-- <b-form-checkbox class="mt-1 mb-1" v-model="type.web" switch>
			{{ $t('global.afficher_web') }}
		</b-form-checkbox> -->

		<b-tabs content-class="mt-3">
			<b-tab
				v-for="locale in locales"
				:key="locale.code"
				:title="locale.title"
				:active="locale.code === localeSelected.code"
				title-link-class="border"
			>
				<div class="row">
					<div class="col-12">
						<e-editor-froala
							v-if="type.contenttype_type == 'editor'"
			                :placeholder="type.contenttype_label"
			                :content="contents[locale.code]"
			                :colorsText="colorsText"
			                @change="updateContent($event, locale.code)"
			            />
			            <b-form-input
			            	v-else-if="type.contenttype_type == 'text'"
			                :placeholder="type.contenttype_label"
			            	class="form-control"
			            	v-model="contents[locale.code]"
			            />
						<div v-else-if="type.contenttype_type == 'boolean'" class="d-flex align-items-center">
							<span class="mr-2">{{ $t('global.non') }}</span>
							<b-form-checkbox
								switch
								v-model="contents[locale.code]"
							/>
							<span class="ml-2">{{ $t('global.oui') }}</span>
						</div>
			        </div>
		        </div>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script type="text/javascript">

	export default {
		name: 'WebContentEdit',
		mixins: [],
		props: ['locales', 'contents', 'type', 'update'],
		data () {
			return {
				localeSelected: {
					title: this.$t('global.lang_fr'),
					code: 'fr'
				},
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {

			},

			updateContent(e, lang) {
				this.update(this.type.contenttype_id, lang, e.val)
			},
		},

		computed: {
			colorsText() {
				const colors = [
	                '#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
	                '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000',
	                '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF',
	                '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', 'REMOVE'
	            ]
				const licenceKey = localStorage.getItem('licence_key')
				// Haras de Semilly
				if(licenceKey == '"1585-5F49-FF42-8E27-C776"') {
					return ['#CD9D41', '#2C2E31'].concat(colors)
				}
				return colors
			},
		}
	}
</script>